module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-LightOblique.af34864d.woff2";